<template>
  <v-dialog :value="show" max-width="500" @input="(val) => outsideClick(val)">
    <v-card class="align-center d-flex flex-column">
      <CloseDialogButton :close="closeAuth" />
      <StorefrontImage class="display-none-height pt-10" size="large" />
      <SMSLogInContent
        :closeAuth="closeAuth"
        :code="code"
        :fetchAccountStatus="fetchAccountStatus"
        :phone="phone"
        :toAuthRoute="toAuthRoute"
        :toLogInRoute="toLogInRoute"
        :updateCode="updateCode"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import SMSLogInContent from "@/components/Auth/LogIn/Content/SMS.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";

export default {
  name: "SMSLogInDialog",
  components: {
    CloseDialogButton,
    SMSLogInContent,
    StorefrontImage,
  },
  props: {
    closeAuth: Function,
    code: Object,
    fetchAccountStatus: Function,
    outsideClick: Function,
    phone: String,
    show: Boolean,
    toAuthRoute: Function,
    toLogInRoute: Function,
    updateCode: Function,
  },
  watch: {
    show(visible) {
      if (visible) {
        this.$store.commit("auth/SHOW_SMS_RETRY_MESSAGE", false);
      }
    }
  },
};
</script>
<style scoped>
@media (max-height: 768px) {
  .display-none-height {
    display: none;
  }
}
</style>
